import { Button, Dialog, DialogCloseButton, DialogContent, DialogHeader } from '@bi-digital/react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FeedbackContent } from './FeedbackContent';
import styles from './FeedbackFooter.module.css';
import type { FeedbackProps } from './Feedback';

export const FeedbackFooter = ({ turnstileSiteKey }: FeedbackProps) => {
    const { t } = useTranslation(['feedback']);
    const [isOpen, setIsOpen] = useState(false);
    const closeTimeout = useRef<ReturnType<typeof setTimeout>>(undefined);

    const open = () => {
        clearTimeout(closeTimeout.current);
        setIsOpen(true);
    };
    const close = () => {
        clearTimeout(closeTimeout.current);
        setIsOpen(false);
    };
    // Keep the confirmation visible briefly, then close.
    const closeAfterSubmit = () => {
        closeTimeout.current = setTimeout(() => setIsOpen(false), 4000);
    };

    return (
        <>
            <Button data-variant='text' onClick={open} aria-haspopup='dialog' aria-expanded={isOpen}>
                {t('feedback')}
            </Button>
            <Dialog
                open={isOpen}
                onClose={close}
                closedby='any'
                className={styles.footerDialog}
                data-color='primary'
                data-color-scheme='light'
            >
                <DialogCloseButton aria-label={t('close')} onClick={close} />
                <DialogHeader noBorder>{t('footer.title')}</DialogHeader>
                <DialogContent noBorder>
                    {/* Remounted per open so the form always starts fresh. */}
                    {isOpen && (
                        <FeedbackContent
                            source='Footer'
                            onSubmitted={closeAfterSubmit}
                            turnstileSiteKey={turnstileSiteKey}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};
